"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_BUSINESS_UNIT = exports.ACCOUNT_CREATED = exports.LOGOUT = exports.LOGIN_FAILURE = exports.LOGIN_SUCCESS = exports.LOGIN_REQUEST = void 0;
var LOGIN_REQUEST = 'zola/auth/LOGGED_IN';
exports.LOGIN_REQUEST = LOGIN_REQUEST;
var LOGIN_SUCCESS = 'zola/auth/LOGIN_SUCCESS';
exports.LOGIN_SUCCESS = LOGIN_SUCCESS;
var LOGIN_FAILURE = 'zola/auth/LOGIN_FAILURE';
exports.LOGIN_FAILURE = LOGIN_FAILURE;
var LOGOUT = 'zola/auth/LOGOUT';
exports.LOGOUT = LOGOUT;
var ACCOUNT_CREATED = 'zola/account/CREATED';
exports.ACCOUNT_CREATED = ACCOUNT_CREATED;
var SET_BUSINESS_UNIT = 'zola/auth/SET_BUSINESS_UNIT';
exports.SET_BUSINESS_UNIT = SET_BUSINESS_UNIT;